/** View modes supported by configuration form drawers. */
export const CONFIG_FORM_VIEW = {
  ADD: 'add',
  EDIT: 'edit',
  DETAILS: 'details',
};

/**
 * Builds the reusable hero summary for configuration form drawers.
 * Mirrors the `configList.hero.*` pattern used by list page heroes.
 *
 * @param {Function} formatMessage - umi useIntl formatMessage
 * @param {{ mode: 'add'|'edit'|'details', resourceKey: string }} options
 * @returns {string}
 */
export const getConfigFormHeroSummary = (formatMessage, { mode, resourceKey }) => {
  const resource = formatMessage({
    id: `configForm.hero.summary.resource.${resourceKey}.${mode}`,
  });

  return formatMessage({ id: `configForm.hero.summary.${mode}` }, { resource });
};
